// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__XXM4D","title":"AfterBackImages_title__26uFw","images":"AfterBackImages_images__1eli-"};